export default __webpack_public_path__ + "static/media/trash.2cf6fdfa.svg";